exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper[data-v-17e30edb]{width:100%;padding:25px 25%\n}\n.form-wrapper .form-wrapper-frame[data-v-17e30edb]{width:100%;padding:25px;margin-bottom:15px\n}\n.form-wrapper .form-wrapper-frame .md-subheading[data-v-17e30edb]{margin-top:35px\n}\n@media(max-width: 1200px){\n.form-wrapper[data-v-17e30edb]{padding:10px .5%;margin-left:0\n}\n}\n.title-icon[data-v-17e30edb]{margin-top:-5px\n}\n#submit-btn[data-v-17e30edb]{margin:25px 0;width:33%;padding:6px;font-size:1.1em\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-17e30edb","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/account/AccountForm.vue
// module id = 119
// module chunks = 0